<template>
	<v-dialog :fullscreen="$vuetify.breakpoint.mobile" width="900px" v-model="dialog">
		<v-card>
			<v-card-title>
				<v-row>
					<v-col cols="9">
						{{ title }}
						<span v-if="vademecumTitulo" :style="{ color: vademecumCor }">{{ vademecumTitulo }}</span>
					</v-col>
					<v-col cols="3" class="d-flex align-center justify-end">
						<v-btn @click="closeDialog" x-large icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<v-text-field 
							v-on:keyup.enter="searchLeis" 
							:disabled="loadingInternalSearch"
							clearable 
							v-model="searchAddLeis" 
							@click:clear="clearInternalSearch"
							@click:append="searchLeis"
							:append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" 
							:color="dynamicColor"
							hide-details 
							outlined
							placeholder="Pesquise pelo número da lei (10.406) ou palavra da ementa (Código Civil)"
							label="Pesquise pelo número da lei (10.406) ou palavra da ementa (Código Civil)" />
					</v-col>
					<v-col v-if="showAdvancedFilters" cols="12" md="8">
						<h4>Filtre por esfera</h4>
						<v-btn-toggle v-model="filterEsfera" mandatory :color="dynamicColor" class="ml-3"
							@change="searchLeis">
							<v-row>
								<v-col cols="6" md="3" class="px-0 mx-0" v-for="o in filterOptions" :key="o.value">
									<v-btn class="mx-0 rounded-0 w-100" :color="dynamicColor" outlined>{{ o.text}}</v-btn>
								</v-col>
							</v-row>
						</v-btn-toggle>
					</v-col>
					<v-col v-if="showAdvancedFilters" cols="12" md="4">
						<v-select 
							class="ml-2" 
							v-if="filterEsfera == 2" 
							:items="selectEstadualOptions"
							v-model="selectEstadualSelected" 
							label="Selecione o estado" 
							outlined 
							hide-details
							@change="searchLeis" 
							:item-color="dynamicColor" 
							:color="dynamicColor" 
							item-text="text"
							item-value="value">
						</v-select>
						<v-select 
							class="ml-2" 
							v-if="filterEsfera == 3" 
							label="Selecione o município"
							:items="selectMunicipalOptions" 
							v-model="selectMunicipalSelected"
							@change="searchLeis" 
							outlined 
							hide-details 
							:color="dynamicColor"
							:item-color="dynamicColor" 
							item-text="text" 
							item-value="value">
						</v-select>
					</v-col>
				</v-row>
				<v-divider class="my-5"></v-divider>
				<h2 v-if="showAdvancedFilters">
					Total de {{ new Intl.NumberFormat("pt-BR").format(this.totalItems) }} leis 
				</h2>
				<v-list class="mt-3">
					<v-list-item class="px-0 text-center d-flex justify-center" v-if="loadingInternalSearch">
						<v-progress-circular :color="dynamicColor" indeterminate></v-progress-circular>
					</v-list-item>
					<v-list-item class="px-0 text-center d-flex justify-center"
						v-if="internalLeisSearch.length === 0 && !loadingInternalSearch">
						<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
					</v-list-item>
					<v-hover v-slot="{ hover }" v-for="item in internalLeisSearch" :key="item.id_lei">
						<v-list-item 
							:class="hover ? `bkgHover` : ``"
							style="border-top: 1px solid #F15A24; border-radius: 10px"
							class="mb-5">
							<v-list-item-content>
								<v-row align="center" class="mb-2" no-gutters>
									<v-col class="pa-0">
										<v-list-item-title>
											<span v-html="highlight(item.numero_lei, searchAddLeis)"></span>
										</v-list-item-title>
									</v-col>
									<v-col class="pa-0 mt-1">
										<v-chip class="mr-2" :color="dynamicColor" outlined :text-color="dynamicColor"
											style="height: 1.5rem">
											{{ item.esfera_lei }}
										</v-chip>
										<v-chip :color="dynamicColor" outlined :text-color="dynamicColor"
											v-if="item.esfera_lei === `Estadual`" style="height: 1.5rem">
											{{ item.estado_lei }}
										</v-chip>
										<v-chip class="ml-2" :color="dynamicColor" outlined :text-color="dynamicColor"
											v-if="item.esfera_lei === `Municipal`" style="height: 1.5rem">
											{{ item.municipio_lei }}
										</v-chip>
									</v-col>
								</v-row>
								<div>
									<small v-html="highlight(item.nome_lei, searchAddLeis)"></small>
								</div>
							</v-list-item-content>

							<v-list-item-action class="text-center">
								<span 
									class="text-subtitle" 
									style="min-width: 90px; text-transform: uppercase" 
									v-if="isLeiInVade(item.id_lei)">
									Adicionado
								</span>
								<v-btn 
									v-else 
									small 
									text 
									:color="dynamicColor" 
									:loading="item.loading || false"
									@click="adicionarLei(item)"
									:disabled="isLeiInVade(item.id_lei) || item.loading">
									Adicionar
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</v-hover>
				</v-list>
				<div v-if="showAdvancedFilters && totalItems > itemsPerPage" class="d-flex justify-center mt-4">
					<v-pagination 
						v-model="currentPage" 
						:total-visible="5"
						:length="Math.ceil(totalItems / itemsPerPage)" 
						:color="dynamicColor" 
						@input="handlePageChange"
						class="mt-4">
					</v-pagination>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DialogAddLei',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		vademecumId: {
			type: [String, Number],
			required: false,
			default: null,
		},
		vademecumTitulo: {
			type: String,
			default: '',
		},
		vademecumCor: {
			type: String,
			default: '#F15A24',
		},
		leisExistentes: {
			type: Array,
			default: () => [],
		},
		dynamicColor: {
			type: String,
			default: '#F15A24',
		},
		showAdvancedFilters: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: 'Adicionar legislação em',
		},
	},
	data() {
		return {
			dialog: this.value,
			searchAddLeis: '',
			loadingInternalSearch: false,
			loadingSearch: false,
			internalLeisSearch: [],
			filterEsfera: 0,
			selectEstadualSelected: '*',
			selectMunicipalSelected: '*',
			currentPage: 1,
			itemsPerPage: 30,
			totalItems: 0,
			filterOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				{ text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				{ text: 'Municipal', value: 'Municipal', disabled: false },
			],
			selectEstadualOptions: [
				{ text: 'Todos', value: '*' },
				{ text: 'Acre', value: 'AC' },
				{ text: 'Alagoas', value: 'AL' },
				{ text: 'Amapá', value: 'AP' },
				{ text: 'Amazonas', value: 'AM' },
				{ text: 'Bahia', value: 'BA' },
				{ text: 'Ceará', value: 'CE' },
				{ text: 'Distrito Federal', value: 'DF' },
				{ text: 'Espírito Santo', value: 'ES' },
				{ text: 'Goiás', value: 'GO' },
				{ text: 'Maranhão', value: 'MA' },
				{ text: 'Mato Grosso', value: 'MT' },
				{ text: 'Mato Grosso do Sul', value: 'MS' },
				{ text: 'Minas Gerais', value: 'MG' },
				{ text: 'Pará', value: 'PA' },
				{ text: 'Paraíba', value: 'PB' },
				{ text: 'Paraná', value: 'PR' },
				{ text: 'Pernambuco', value: 'PE' },
				{ text: 'Piauí', value: 'PI' },
				{ text: 'Rio de Janeiro', value: 'RJ' },
				{ text: 'Rio Grande do Norte', value: 'RN' },
				{ text: 'Rio Grande do Sul', value: 'RS' },
				{ text: 'Rondônia', value: 'RO' },
				{ text: 'Roraima', value: 'RR' },
				{ text: 'Santa Catarina', value: 'SC' },
				{ text: 'São Paulo', value: 'SP' },
				{ text: 'Sergipe', value: 'SE' },
				{ text: 'Tocantins', value: 'TO' },
			],
			selectMunicipalOptions: [
				{ text: 'Todos', value: '*' },
			],
			leisExistentesLocal: [],
		};
	},
	watch: {
		value(newVal) {
			this.dialog = newVal;
			if (newVal) {
				// Quando o dialog é aberto, sincronizar completamente com a prop atualizada
				// Isso garante que leis excluídas não apareçam como "já adicionadas"
				this.leisExistentesLocal = this.leisExistentes ? [...this.leisExistentes] : [];
				
				// Se tem filtros avançados, buscar automaticamente ao abrir
				if (this.showAdvancedFilters) {
					this.searchLeis();
				}
			} else {
				this.clearInternalSearch();
			}
		},
		dialog(newVal) {
			this.$emit('input', newVal);
		},
		leisExistentes: {
			handler(newVal) {
				// Se o dialog está aberto, sincronizar com a prop atualizada
				// Isso garante que quando uma lei é excluída, ela seja removida da lista local
				if (this.dialog) {
					const newLeis = newVal ? [...newVal] : [];
					
					// Criar um mapa das leis da prop para busca rápida
					const propLeisMap = new Map();
					newLeis.forEach(lei => {
						const idLei = lei.leis_id_lei ? lei.leis_id_lei.id_lei : lei.id_lei;
						if (idLei) {
							propLeisMap.set(parseInt(idLei), lei);
						}
					});
					
					// Adicionar apenas leis que foram adicionadas localmente durante esta sessão
					// e que ainda não estão na prop (aguardando confirmação do servidor)
					this.leisExistentesLocal.forEach(localLei => {
						const idLei = localLei.leis_id_lei ? localLei.leis_id_lei.id_lei : localLei.id_lei;
						if (idLei) {
							const jaExiste = propLeisMap.has(parseInt(idLei));
							// Só adicionar se não existe na prop E se foi adicionada nesta sessão (tem id null)
							if (!jaExiste && localLei.id === null) {
								newLeis.push(localLei);
							}
						}
					});
					
					this.leisExistentesLocal = newLeis;
				} else {
					// Se o dialog está fechado, apenas atualizar quando necessário
					this.leisExistentesLocal = newVal ? [...newVal] : [];
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		closeDialog() {
			this.dialog = false;
		},
		clearInternalSearch() {
			this.searchAddLeis = '';
			this.totalItems = 0;
			this.internalLeisSearch = [];
			this.currentPage = 1;
		},
		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, 'gi'), (match) => {
				return '<span class="my-orange">' + match + '</span>';
			});
		},
		isLeiInVade(leiId) {
			if (!this.leisExistentesLocal || this.leisExistentesLocal.length === 0) return false;
			return this.leisExistentesLocal.some(
				(e) => parseInt(e.leis_id_lei ? e.leis_id_lei.id_lei : e.id_lei) === parseInt(leiId)
			);
		},
		handlePageChange() {
			this.searchLeis();
		},
		async searchLeis() {
			// Se não há texto de busca e não está usando filtros avançados, não buscar
			if (!this.showAdvancedFilters && (!this.searchAddLeis || this.searchAddLeis.trim() === '')) {
				this.internalLeisSearch = [];
				return;
			}
			
			if (this.showAdvancedFilters) {
				await this.searchLeisAdvanced();
			} else {
				await this.searchLeisSimple();
			}
		},
		async searchLeisAdvanced() {
			if (this.searchAddLeis == null) this.searchAddLeis = "";
			if (!isNaN(this.searchAddLeis) && this.searchAddLeis.indexOf('.') == -1) {
				this.searchAddLeis = this.searchAddLeis.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
			}

			const searchQuery = this.searchAddLeis
				? `search:"${this.searchAddLeis}", `
				: '';

			const offset = (this.currentPage - 1) * this.itemsPerPage;

			let filter = 'filter: { esfera_lei: { _nnull: true}}'
			if (this.filterEsfera == 1) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"} }, `
			}

			if (this.filterEsfera == 2) {
				filter = `filter: {  esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado_lei: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsfera == 3) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio_lei: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}

			const query = `
				query FilterByApelidosLeis {
					leis(${filter}${searchQuery}sort: ["-ranking_lei", "-data_lei"], limit: ${this.itemsPerPage}, offset: ${offset}) {
					id_lei
					numero_lei
					data_lei
					nome_lei
					estado_lei
					municipio_lei
					esfera_lei
					ranking_lei
					}
					leis_aggregated(${filter}${searchQuery}) {
					count { id_lei }
					}
				}
				`;

			this.loadingInternalSearch = true;
			this.internalLeisSearch = [];
			this.totalItems = 0;

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { leis, leis_aggregated } = response.data.data;
				this.internalLeisSearch = leis.map(v => ({ ...v, loading: false }));
				this.totalItems = leis_aggregated[0].count.id_lei;
				this.loadingInternalSearch = false;
			} catch (error) {
				this.loadingInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error.response);
			}
		},
		async searchLeisSimple() {
			if (!this.searchAddLeis || this.searchAddLeis.trim() === '') {
				this.internalLeisSearch = [];
				return;
			}

			this.loadingInternalSearch = true;
			this.internalLeisSearch = [];

			try {
				const { data } = await this.$http.get(
					`items/leis?filter[_or][0][numero_lei][_contains]=${this.searchAddLeis}&filter[_or][1][nome_lei][_contains]=${this.searchAddLeis}&limit=20&fields=id_lei,numero_lei,nome_lei,esfera_lei,estado_lei,municipio_lei`
				);

				// Inicializar loading como false e garantir reatividade
				this.internalLeisSearch = (data.data || []).map(v => {
					const item = { ...v, loading: false };
					this.$set(item, 'loading', false);
					return item;
				});
			} catch (error) {
				window.console.error('Erro ao buscar leis:', error);
			} finally {
				this.loadingInternalSearch = false;
			}
		},
		async adicionarLei(lei) {
			// Verificar se a lei já foi adicionada antes de iniciar
			if (this.isLeiInVade(lei.id_lei)) {
				return;
			}

			// Verificar se vademecumId está definido
			if (!this.vademecumId) {
				window.console.error('vademecumId não está definido');
				return;
			}

			// Usar $set para garantir reatividade
			this.$set(lei, 'loading', true);
			
			try {
				let success = false;
				// Tentar usar o método patch primeiro (para vade-mécuns pessoais)
				try {
					await this.$http.patch('/items/vademecums/' + this.vademecumId, {
						leis: {
							create: [
								{
									leis_id_lei: { id_lei: lei.id_lei },
									vademecums_id: this.vademecumId,
								},
							],
						},
					});
					success = true;

					// Atualizar ranking da lei
					try {
						const res = await this.$http.get('/items/leis/' + lei.id_lei);
						if (res && res.data && res.data.data) {
							const newRanking = res.data.data.ranking_lei + 1;
							await this.$http.patch('/items/leis/' + lei.id_lei, {
								ranking_lei: newRanking,
							});
						}
					} catch (error) {
						window.console.error('Erro ao atualizar ranking:', error);
					}
				} catch (patchError) {
					// Se o patch falhar, tentar criar diretamente na tabela de relacionamento (para grupos)
					try {
						await this.$http.post('items/vademecums_leis', {
							vademecums_id: this.vademecumId,
							leis_id_lei: lei.id_lei
						});
						success = true;
					} catch (postError) {
						window.console.error('Erro ao adicionar lei via POST:', postError);
						throw postError;
					}
				}

				if (success) {
					// Adicionar a lei à lista local de leis existentes para atualizar a UI imediatamente
					// Isso faz com que o botão mude para "Adicionado" sem precisar recarregar
					if (!this.leisExistentesLocal.some(e => {
						const idLei = e.leis_id_lei ? e.leis_id_lei.id_lei : e.id_lei;
						return parseInt(idLei) === parseInt(lei.id_lei);
					})) {
						// Adicionar à lista local usando push (reativo)
						this.leisExistentesLocal.push({
							leis_id_lei: { id_lei: lei.id_lei },
							id: null // ID da relação será definido quando recarregar
						});
					}
					
					// Emitir evento para o componente pai recarregar os dados
					this.$emit('lei-adicionada', lei);
				}
				
				this.$set(lei, 'loading', false);
			} catch (error) {
				window.console.error('Erro ao adicionar lei:', error);
				this.$set(lei, 'loading', false);
			}
		},
	},
};
</script>

<style scoped>
.bkgHover {
	background-color: #FFF8F5;
}
</style>

